import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { ITab, ITabsComponent } from "@front/m19-ui";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-dsp-blacklist-page",
  imports: [ITabsComponent, RouterOutlet, TranslocoDirective],
  templateUrl: "./dsp-blacklist-page.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspBlacklistPageComponent {
  private readonly translocoService = inject(TranslocoService);

  readonly inventoryTypeTabs: ITab<string>[] = [
    { value: "domain", url: "domain", label: this.translocoService.translate("dsp-blacklist.sites") },
    { value: "app", url: "app", label: this.translocoService.translate("dsp-blacklist.apps") },
  ];
}
